import React, { useState, useEffect } from "react";
import Modal from "../../../../components/Common/Modal/Modal";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { seriesHistory } from "../../../../utils/mainTabs/distribute/distributeHistory";
import { useDispatch } from "react-redux";
import { getProgramDistributionHistoryActionHandler } from "../../../../store/actions/actionHandlers/distributeActionHandler";

const SeriesHistoryModal = ({ historyModal, setHistoryModal, programId }) => {
  const [tableColumns, setTableColumns] = useState([]);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    let newTableColumns = seriesHistory?.columns();
    setTableColumns(newTableColumns);
    dispatch(
      getProgramDistributionHistoryActionHandler(
        programId,
        setHistoryData,
        setLoader
      )
    );
  }, [dispatch, programId]);

  return (
    <Modal
      isOpen={historyModal}
      toggle={() => setHistoryModal(false)}
      width={"90"}
      heading={"Distribution History"}
    >
      <DataTable
        columns={tableColumns}
        defaultData={historyData}
        data={historyData}
        totalRows={historyData?.length}
        loading={loader}
        uniqueFieldName={"Id"}
      />
    </Modal>
  );
};

export default SeriesHistoryModal;
